import Vue from "vue";
import Vuex from "vuex";
import layout from "./layout.module";
import alert from "./alert.module";
import device from "./device.module";
import dashboard from "./dashboard.module";
import upgrades from "./upgrades.module";
import circuit from "./circuit.module";



Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    layout,
    alert,
    device,
    dashboard,
    upgrades,
    circuit
  }
});
